import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';
import { Concert } from 'interfaces';

import concertsDataRaw from 'data/concerts.json';

const concertsData: Concert[] = concertsDataRaw as unknown as Concert[];

export const getConcert = (concertId, locale = AppLocale.EN, intl, field: 'name' | 'link' = 'name') => {
  const concert = concertsData.filter((song) => song.id === concertId)[0];

  switch (field) {
    case 'name': {
      return intl.formatMessage({ id: 'concert.name' }, {
          bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP,
          name: concert.name ? `${intl.formatMessage({ id: `concert.name.${concert.name}` })}${locale === AppLocale.EN ? ', ' : '、'}` : '',
          venue: intl.formatMessage({ id: `concert.venue.${concert.venueId}` }),
          city: intl.formatMessage({ id: `concert.city.${concert.cityId}` }),
          country: intl.formatMessage({ id: `concert.country.${concert.countryId}` })
        });
    }
    case 'link': {
      return concert.tourId !== 'festivals-shows-special-events'
        ? `/tours-and-shows/${concert.tourId}/${concert.id}`
        : `/tours-and-shows/shows/festivals-shows-special-events/${concert.date.split('-')[0]}/${concert.id}`;
    }
  }
}
